import { actionTypes } from "../actions/analytics";

const variable = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAMPAIGN_ANALYSIS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;